import React from 'react';
import './TimelineEventsPartyLegend.scss';

const TimelineEventsPartyLegend = () => {
    return (
        <div className="tooltip-legend">
            <div className="tooltip-legend-item buyer-party">
                <span className="legend-indicator"></span>
                <span>Buyer Party</span>
            </div>
            <div className="tooltip-legend-item seller-party">
                <span className="legend-indicator"></span>
                <span>Seller Party</span>
            </div>
            <div className="tooltip-legend-item seller-buyer-party">
                <span className="legend-indicator"></span>
                <span>Seller & Buyer Party</span>
            </div>
            <div className="tooltip-legend-item vetvalue-party">
                <span className="legend-indicator"></span>
                <span>VetValue Party</span>
            </div>
        </div>
    );
};

export default TimelineEventsPartyLegend;
